import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const InformacionGeneralComplemento = ({
    register,
    selectedValuesDDL,
    setSelectedValuesDDL,
    errors,
    clearError,
    setValue,
    now,
    minDate
}) => {
    const registerField = (name = '') => register && typeof register === 'function' ? register(name) : {};

    const formatLocalDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    // Asegurar que vSerie tenga un valor en react-hook-form
    useEffect(() => {
        const serieValue = selectedValuesDDL.vSerie || 'P';
        setValue('vSerie', serieValue);
    }, [selectedValuesDDL.vSerie, setValue]);

    return (
        <>
            <h5 className="mt-3 mb-3 bg-light p-2 rounded text-dark">Información General del Complemento</h5>
            <Row className="g-2">
                <Col md={4}>
                    <Form.Group>
                        <Form.Label>Serie</Form.Label>
                        <Form.Select
                            size="sm"
                            value={selectedValuesDDL.vSerie || 'P'}
                            onChange={(e) => {
                                const serie = e.target.value;
                                setSelectedValuesDDL({ ...selectedValuesDDL, vSerie: serie });
                                setValue('vSerie', serie);
                                clearError('vSerie');
                            }}
                        >
                            <option value="P">P</option>
                            <option value="PA">PA</option>
                            <option value="CP">CP</option>
                        </Form.Select>
                        {errors.vSerie && <div className="text-danger small">{errors.vSerie}</div>}
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label>Folio</Form.Label>
                        <Form.Control
                            size="sm"
                            type="text"
                            value={selectedValuesDDL.vFolio || ''}
                            {...registerField('vFolio')}
                            onChange={(e) => {
                                const newFolio = e.target.value;
                                setSelectedValuesDDL({ ...selectedValuesDDL, vFolio: newFolio });
                                setValue('vFolio', newFolio, { shouldValidate: true });
                            }}
                        />
                        {errors.vFolio && <div className="text-danger small">{errors.vFolio}</div>}
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label>Fecha de Emisión</Form.Label>
                        <Form.Control
                            size="sm"
                            type="datetime-local"
                            {...registerField('dFechaEmision')}
                            max={formatLocalDateTime(now)}
                            min={formatLocalDateTime(minDate)}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </>
    );
};

InformacionGeneralComplemento.propTypes = {
    register: PropTypes.func.isRequired,
    selectedValuesDDL: PropTypes.object.isRequired,
    setSelectedValuesDDL: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    clearError: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    now: PropTypes.instanceOf(Date).isRequired,
    minDate: PropTypes.instanceOf(Date).isRequired
};

export default InformacionGeneralComplemento;
